export const GRADES = ["1st Year", "2nd Year", "3rd Year", "4th Year", "Qualified", "Foreman", "Project Manager"];

// Default (random) hourly rate prefilled when a grade is selected. Editable.
export const GRADE_RATES = {
  "1st Year": 14.50,
  "2nd Year": 17.25,
  "3rd Year": 20.75,
  "4th Year": 24.50,
  "Qualified": 29.50,
  "Foreman": 34.00,
  "Project Manager": 39.00,
};
